module.exports = __webpack_public_path__ + "5ee958a60c831a74f998cf6f26538997.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Bold.eot
// module id = 415
// module chunks = 0